export const REDO = 'REDO';

export const redoAction = (): any => {
  return {
    type: REDO,
  };
};
